import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useTheme, Box, FormControl, TextField, IconButton } from "@mui/material";
import { tokens } from "../../theme";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

export default function QuestionPreviewForTest({ numChoices, setNumChoices, setOptionName, optionName, readOnlyNames = false }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const handleOptionNameChange = (index, newName) => {
        const updatedOptions = [...optionName];
        updatedOptions[index] = newName;
        setOptionName(updatedOptions);
    };

    const handleAddChoice = () => {
        const nextLetter = String.fromCharCode(65 + numChoices); // A=65, B=66, etc.
        setOptionName([...optionName, nextLetter]);
        setNumChoices(Number(numChoices) + 1);
    };

    const handleRemoveChoice = (index) => {
        if (numChoices > 2) {
            const updatedOptions = optionName.filter((_, i) => i !== index);
            setOptionName(updatedOptions);
            setNumChoices(Number(numChoices) - 1);
        }
    };

    return (
        <Card
            sx={{
                position: "relative",
                minWidth: "100%",
                minHeight: "100%",
                backgroundColor: colors.primary[600],
                border: `1px solid ${colors.primary[600]}`,
            }}
        >
            <CardContent
                sx={{
                    paddingX: 0,
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "space-between", paddingX: '10px' }}>
                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 0.5,                        
                        }}
                    >
                        <Typography variant="h4">
                            {"A Question Preview"}
                        </Typography>
                    </Box>
                </Box>
                <br/>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", ml: 3, mr: 3}}>
                        {Array.from({ length: numChoices }).map((_, index) => (
                            <Box key={index} sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <Typography>{index + 1}.</Typography>
                                <TextField
                                    variant="filled"
                                    placeholder='Option Name'
                                    value={optionName[index] || ''}
                                    onChange={(e) => handleOptionNameChange(index, e.target.value)}
                                    disabled={readOnlyNames}
                                    sx={{ width: "100%" }}
                                    size="small"
                                />
                                <IconButton
                                    onClick={() => handleRemoveChoice(index)}
                                    size="small"
                                    disabled={numChoices <= 2}
                                    sx={{
                                        color: numChoices > 2 ? colors.redAccent[400] : colors.grey[600],
                                        p: 0.5,
                                    }}
                                >
                                    <RemoveCircleOutlineIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        ))}
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                            <IconButton
                                onClick={handleAddChoice}
                                size="small"
                                sx={{ color: colors.blueAccent[400] }}
                            >
                                <AddCircleOutlineIcon />
                            </IconButton>
                            <Typography variant="caption" sx={{ color: colors.grey[400] }}>
                                Add choice
                            </Typography>
                        </Box>
                    </Box>             
                <br/>
                <FormControl>
                    --------------------------------------------------------------------------------
                    <Typography sx={{mt: 2, ml: 2}} variant="h5">A sample answer form</Typography>
                    <br/>
                    <RadioGroup
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        sx={{ display: "flex", gap: "10px", ml: 3 }}
                    >
                        {optionName.slice(0, numChoices).map((option, index) => (
                            <FormControlLabel
                                key={index}
                                value={option}
                                control={<Radio />}
                                label={option}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </CardContent>
        </Card>
    );
}
